<template>
  <div class="home">
    <ReturnList ref="refreshList"/>
  </div>
</template>

<script>
// @ is an alias to /src
import ReturnList from '@/components/return/ReturnList.vue'

export default {
  name: 'Return',
  components: {
    ReturnList
  },
  mounted () {
    this.$store.dispatch('getSalesList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getProductList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getSalesTypeList')
  }
}
</script>
